module.exports = {"bewizr-agenda":{"empty":{"title":"Nincs esemény","detail":"Nincsenek ütemezett eseményei."}}}